import styles from "./DocumentItem.module.css";
import PropTypes from "prop-types";

/**
 *
 * Displays an icon and description.
 *
 */

export function DocumentItem({ icon, description, onClick }) {
  return (
    <div className={styles.container} onClick={onClick}>
      <img src={icon} className={styles.icon}/>

      <div>{description}</div>
    </div>
  );
}

DocumentItem.propTypes = {
  icon: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
};
